/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SITE NAV MODULE
\*------------------------------------*/
class SiteNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.dropdowns();
        self.navToggle();
    }

    navToggle() {
        let self = this;

        const toggle = document.querySelector('[data-nav-toggle]');
        const nav = document.querySelector('[data-nav]');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();

            toggle.classList.toggle('is-active');
            $('.js-site-nav__app').toggleClass('is-active');
            $('body').toggleClass('is-no-scroll');
        });
    }

    dropdowns() {
        let self = this;

        const dropdowns = self.elem.querySelectorAll('[data-nav-dropdown]');

        dropdowns.forEach(elem => {
            let trigger = elem.querySelector('[data-nav-dropdown-trigger]');
            let dropdown = elem.querySelector('[data-nav-dropdown-menu]');

            trigger.addEventListener('click', evt => {
                evt.preventDefault();
                dropdown.classList.toggle('show');
                trigger.classList.toggle('show');
            });

            // Listen for clicks outside of this nav element and
            // close the dropdown
            document.addEventListener('click', evt => {
                if (!elem.contains(evt.target)) {
                    dropdown.classList.remove('show');
                    trigger.classList.remove('show');
                }
            });
        });
    }
}

export default SiteNav;